import React, { createContext, useState } from 'react';

export const LogsContext = createContext();

export const LogsProvider = ({ children }) => {
  const [page, setPage] = useState(1);
  const [filterBody, setFilterBody] = useState();
  const [idFilter, setIdFilter] = useState([]);
  const [typeFilter, setTypeFilter] = useState([]);
  const [messageFilter, setMessageFilter] = useState([]);
  const [stackFilter, setStackFilter] = useState([]);
  const [detailsFilter, setDetailsFilter] = useState([]);
  const [apiUrlFilter, setApiUrlFilter] = useState([]);
  const [httpRequestFilter, setHttpRequestFilter] = useState([]);
  const [httpResponseFilter, setHttpResponseFilter] = useState([]);
  const [dateTimeLtFilter, setDateTimeLtFilter] = useState();
  const [dateTimeGtFilter, setDateTimeGtFilter] = useState();
  const [paymentIdFilter, setPaymentIdFilter] = useState([]);
  const [orderIdFilter, setOrderIdFilter] = useState([]);
  const [membershipOrderIdFilter, setMembershipOrderIdFilter] = useState([]);
  const [paymentCardIdFilter, setPaymentCardIdFilter] = useState([]);
  const [deviceIdFilter, setDeviceIdFilter] = useState([]);
  const [clientIdFilter, setClientIdFilter] = useState([]);
  const [sortOrder, setSortOrder] = useState('asc');

  const clearFilters = callback => {
    setIdFilter([]);
    setTypeFilter([]);
    setMessageFilter([]);
    setStackFilter([]);
    setDetailsFilter([]);
    setApiUrlFilter([]);
    setHttpRequestFilter([]);
    setHttpResponseFilter([]);
    setDateTimeGtFilter();
    setDateTimeLtFilter();
    setPaymentIdFilter([]);
    setOrderIdFilter([]);
    setMembershipOrderIdFilter([]);
    setPaymentCardIdFilter([]);
    setDeviceIdFilter([]);
    setClientIdFilter([]);
    setFilterBody();

    if (callback) callback();
  };

  return (
    <LogsContext.Provider
      value={{
        page,
        setPage,
        filterBody,
        setFilterBody,
        idFilter,
        setIdFilter,
        typeFilter,
        setTypeFilter,
        messageFilter,
        setMessageFilter,
        stackFilter,
        setStackFilter,
        detailsFilter,
        setDetailsFilter,
        apiUrlFilter,
        setApiUrlFilter,
        httpRequestFilter,
        setHttpRequestFilter,
        httpResponseFilter,
        setHttpResponseFilter,
        dateTimeLtFilter,
        setDateTimeLtFilter,
        dateTimeGtFilter,
        setDateTimeGtFilter,
        paymentIdFilter,
        setPaymentIdFilter,
        orderIdFilter,
        setOrderIdFilter,
        membershipOrderIdFilter,
        setMembershipOrderIdFilter,
        paymentCardIdFilter,
        setPaymentCardIdFilter,
        deviceIdFilter,
        setDeviceIdFilter,
        clientIdFilter,
        setClientIdFilter,
        sortOrder,
        setSortOrder,
        clearFilters,
      }}
    >
      {children}
    </LogsContext.Provider>
  );
};
